/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommentDto } from '../../models/comment-dto';
import { SetCommentResolvedRequest } from '../../models/set-comment-resolved-request';

export interface CommentsCommentIdResolvePost$Json$Params {
  commentId: string;
      body?: SetCommentResolvedRequest
}

export function commentsCommentIdResolvePost$Json(http: HttpClient, rootUrl: string, params: CommentsCommentIdResolvePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
  const rb = new RequestBuilder(rootUrl, commentsCommentIdResolvePost$Json.PATH, 'post');
  if (params) {
    rb.path('commentId', params.commentId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CommentDto>;
    })
  );
}

commentsCommentIdResolvePost$Json.PATH = '/comments/{commentId}/resolve';
